/**
 * BoardV3 Column Backgrounds
 * Renders alternating column backgrounds and separator lines.
 * Reads all data from hooks (0 props).
 */

import React, { memo } from 'react';
import { getMaxRow } from '../utils/boardHelpers';
import { useColumnYOffsets, useRowAssignments, useRowHeight, useHeaderHeight } from './BoardLayoutContext';
import { useColumnNames } from '../../stores/hooks';

export const BoardV3ColumnBackgrounds = memo(function BoardV3ColumnBackgrounds() {
  const columns = useColumnNames();
  const columnYOffsets = useColumnYOffsets();
  const rowAssignments = useRowAssignments();
  const rowHeight = useRowHeight();
  const headerHeight = useHeaderHeight();

  return (
    <>
      {columns.map((column, index) => {
        const yOffset = columnYOffsets[column] ?? 0;
        const rowCount = Math.max(1, getMaxRow(rowAssignments[column]) + 1);
        const height = rowCount * rowHeight + 8;
        return (
          <React.Fragment key={`col-bg-${column}`}>
            {index % 2 !== 0 && (
              <div
                style={{
                  position: 'absolute',
                  top: headerHeight + yOffset,
                  left: 0,
                  right: 0,
                  height,
                  backgroundColor: 'rgba(0, 0, 0, 0.02)',
                  pointerEvents: 'none',
                }}
              />
            )}
            <div
              style={{
                position: 'absolute',
                top: headerHeight + yOffset + height - 1,
                left: 0,
                right: 0,
                height: 1,
                backgroundColor: 'rgba(0, 0, 0, 0.1)',
                pointerEvents: 'none',
              }}
            />
          </React.Fragment>
        );
      })}
    </>
  );
});
